import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore';
import 'firebase/compat/auth'; 

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyAZWfeoQbBswct00YSFs8WAsA0hLhM3kw8",
  authDomain: "im-app-2e717.firebaseapp.com",
  projectId: "im-app-2e717",
  storageBucket: "im-app-2e717.appspot.com",
  messagingSenderId: "231822871506",
  appId: "1:231822871506:web:d5f6fbd53083f20181560b",
  measurementId: "G-BWMBB844D9"
})

const db = firebaseApp.firestore()

const auth = firebase.auth()

export { db, auth }
